<div class="problem-row-compact" *ngIf="mode == 'compact'">
    <div style="position:relative;">
        <div style="float:left;" class="row-icons" matTooltip="Modifier le problème" matTooltipPosition="above"><fa-icon (click)="editProblem()" [icon]="['fas', 'file-signature']" class="edit-icon" size="lg"></fa-icon></div>
        <div style="float:left;" matTooltip="Problème significatif" matTooltipPosition="above"><fa-icon *ngIf="significant" (click)="toggleRisk()" [icon]="['fas', 'circle']" [ngClass]="{'problem-significant-none': !significant, 'problem-significant': significant == 'significant', 'problem-significant-not': significant == 'notsignificant'}" size="lg"></fa-icon></div>
        <div style="float:left;" matTooltip="Problème à risque" matTooltipPosition="above"><fa-icon *ngIf="risk" (click)="toggleRisk()" [icon]="['fas', 'exclamation-triangle']" [ngClass]="{'problem-risk': risk, 'problem-norisk': !risk}" size="lg"></fa-icon></div>
        <div style="float:left;" matTooltip="Antécédent familial" matTooltipPosition="above"><fa-icon *ngIf="family" (click)="toggleRisk()" [icon]="['fas', 'house-user']" [ngClass]="{'problem-family': family, 'problem-notfamily': !family}" size="lg"></fa-icon></div>
        <div style="float:right;">{{ startDate }}</div>
    </div>
    <div style="clear:both;">{{ record.value }}</div>
</div>
<div class="problem-row-full" [ngClass]="{'problem-finished-row': active}"  *ngIf="mode == 'full'">
    <div class="flex-container problem-row-header" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
        <div fxFlex="80px">
            <div>
                <div class="flex-container problem-row-icons" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
                    <fa-icon (click)="editProblem()" [icon]="['fas', 'file-signature']" class="edit-icon" size="lg"></fa-icon>
                    <fa-icon (click)="openAccess()" [icon]="['fas', 'user-lock']" class="access-icon" size="lg"></fa-icon>
                </div>
            </div>
            <div class="row-date">{{ startDate }}</div>
            <div class="row-date">{{ endDate }}</div>
        </div>
        <div fxFlex="25px">
            <fa-icon *ngIf="significant" (click)="toggleRisk()" [icon]="['fas', 'circle']" [ngClass]="{'problem-significant-none': !significant, 'problem-significant': significant == 'significant', 'problem-significant-not': significant == 'notsignificant'}" size="lg"></fa-icon>
        </div>
        <div fxFlex="25px">
            <fa-icon *ngIf="risk" (click)="toggleRisk()" [icon]="['fas', 'exclamation-triangle']" [ngClass]="{'problem-risk': risk, 'problem-norisk': !risk}" size="lg"></fa-icon>
        </div>
        <div fxFlex="25px">
            <fa-icon *ngIf="family" (click)="toggleRisk()" [icon]="['fas', 'house-user']" [ngClass]="{'problem-family': family, 'problem-notfamily': !family}" size="lg"></fa-icon>
        </div>
        <div fxFlex="350px">
            <div class="problem-content" [innerHtml]="content | crToBr | safeHtml"></div>
        </div>
        <div fxFlex="grow">
            <div class="problem-description" [innerHtml]="description | crToBr | safeHtml"></div>
        </div>
        <div fxFlex="50px">
            <div class="problem-cisp" [innerHtml]="cisp | crToBr | safeHtml"></div>
        </div>
    </div>
</div>